/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

import Vue from "vue";
import VueRouter from "vue-router";
import { getUserGuid, common, config } from "assets/js/util";

/**
 * 处理路由页面切换时，异步组件加载过渡的处理函数
 * @param {Object} AsyncView 需要加载的组件，如 import('@/components/home/Home.vue')
 * @return {Object} 返回一个promise对象
 */
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require("base/page-loading/page-loading.vue").default,
    // 加载失败时使用的组件

    error: require("base/page-loadfail/page-loadfail.vue").default,
    delay: 200,
    timeout: 50000
  });
  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children);
    }
  });
}

/* 下单 */
const orderIndex = () =>
  lazyLoadView(
    import(/* webpackChunkName: "orderIndex" */ "components/order/index")
  );
const orderInquire = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "orderInquire" */ "components/order/inquire/inquire"
    )
  );
const orderSubmitAudit = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "submitAudit" */ "components/order/submitAudit/submitAudit"
    )
  );
const result = () =>
  lazyLoadView(
    import(/* webpackChunkName: "result" */ "components/result/result")
  );

/* 用户中心 */

const userIndex = () =>
  lazyLoadView(
    import(/* webpackChunkName: "userIndex" */ "components/user/index")
  );
const myInfo = () =>
  lazyLoadView(
    import(/* webpackChunkName: "myInfo" */ "components/user/personCenter/info")
  );
const myPw = () =>
  lazyLoadView(
    import(/* webpackChunkName: "myPw" */ "components/user/personCenter/pw")
  );

const NotFoundComponent = () =>
  lazyLoadView(
    import(/* webpackChunkName: "NotFoundComponent" */ "components/error/404")
  );

// 现货
const spotGoods = () =>
  lazyLoadView(
    import(/* webpackChunkName: "spotGoods" */ "components/goods/goods")
  );
const goodsIndex = () =>
  lazyLoadView(
    import(/* webpackChunkName: "goodsIndex" */ "components/goods/index/index")
  );
const testpage = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "goodsIndex" */ "components/goods/index/testpage"
    )
  );
const goodsDetail = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "goodsDetail" */ "components/goods/detail/detail"
    )
  );
const goodsInfo = () =>
  lazyLoadView(
    import(/* webpackChunkName: "goodsInfo" */ "components/goods/info/info")
  );

// 扑克牌活动
const poker = () =>
  lazyLoadView(
    import(/* webpackChunkName: "poker" */ "components/activities/poker/poker")
  );

// cad
const cad = () =>
  lazyLoadView(import(/* webpackChunkName: "cad" */ "components/cad/cad"));
const cadIndex = () =>
  lazyLoadView(
    import(/* webpackChunkName: "cadIndex" */ "components/cad/index/index")
  );
// bom解析页面
const bomAnalysis = () =>
  lazyLoadView(
    import(/* webpackChunkName: "bomAnalysis" */ "components/bom/index")
  );
const bomList = () =>
  lazyLoadView(
    import(/* webpackChunkName: "bomList" */ "components/bom/bomList/bomList")
  );
const bomSubmit = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "bomSubmit" */ "components/bom/bomSubmit/bomSubmit"
    )
  );
const testPage = () =>
  lazyLoadView(import(/* webpackChunkName: "test" */ "components/bom/test"));

const compIndex = () =>
  lazyLoadView(
    import(/* webpackChunkName: "compIndex" */ "components/bom/comp/comp")
  );

Vue.use(VueRouter);
const Router = new VueRouter({
  linkActiveClass: "active",
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (to.name !== "rootResult" && savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0
    };
  },
  // process.env.NODE_ENV === 'production' ? '/' : '/kbidmOrder/'
  base: "/",
  routes: [
    {
      path: "/",
      redirect: {
        name: "rootOrderIndex"
      }
    },
    {
      path: "/index",
      component: orderIndex,
      name: "rootOrderIndex",
      redirect: {
        name: "orderInquire"
      },
      children: [
        {
          path: "inquire",
          component: orderInquire,
          name: "orderInquire",
          meta: {
            requiresAuth: false,
            title: "造物云_PCB询价_pcb在线计价_BOM询价_pcb加急打样"
          }
        },
        {
          path: ":type(PCB|PCBA|BOM)",
          name: "orderInquireType",
          component: orderInquire,
          meta: {
            title:
              "造物云 | 电子设计与制造服务平台_专业PCB_PCBA_BOM_元器件_电子工程服务_高速PCB设计-造物云"
          }
        },
        {
          path: "submitAudit",
          component: orderSubmitAudit,
          name: "orderSubmitAudit",
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/user",
      component: userIndex,
      name: "rootUser",
      children: [
        {
          path: "myInfo",
          component: myInfo,
          name: "userMyInfo"
        },
        {
          path: "myPw",
          component: myPw,
          name: "userMyPw"
        }
      ]
    },
    {
      path: "/result",
      component: result,
      name: "rootResult",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "*",
      component: NotFoundComponent,
      beforeEnter: (to, from, next) => {
        window.location.replace(`${config.domain}/view/404.html`);
        next();
      }
    },
    {
      path: "/goods",
      component: spotGoods,
      name: "spotGoods",
      children: [
        {
          path: "index",
          component: goodsIndex,
          name: "index",
          meta: {
            title: "BOM服务_E-BOM_P-BOM_M-BOM_造物云"
          }
        },
        {
          path: "testpage",
          component: testpage,
          name: "testpage",
          meta: {
            title:
              "造物云 | 电子设计与制造服务平台_专业PCB_PCBA_BOM_元器件_电子工程服务_高速PCB设计-造物云"
          }
        },
        {
          path: "detail",
          component: goodsDetail,
          name: "detail",
          meta: {
            title:
              "造物云 | 电子设计与制造服务平台_专业PCB_PCBA_BOM_元器件_电子工程服务_高速PCB设计-造物云"
          }
        },
        {
          path: "info",
          component: goodsInfo,
          name: "info",
          meta: {
            title: "元器件"
          }
        }
      ]
    },
    {
      path: "/poker",
      component: poker,
      name: "poker",
      meta: {
        requiresAuth: true,
        title: "造物云 | 活动"
      }
    },
    {
      path: "/cadIndex",
      component: cad,
      name: "cadIndex",
      meta: {
        requiresAuth: true,
        title: "造物云动态_高速PCB设计_SI设计_封装库"
      }
    },
    {
      path: "/cad",
      component: cadIndex,
      name: "cad",
      meta: {
        requiresAuth: true,
        title: "高速PCB设计_PCB Layout_EMC设计与整改_造物云"
      }
    },
    {
      path: "/bom",
      component: bomAnalysis,
      name: "bom",
      meta: {
        requiresAuth: true,
        title:
          "造物云 | 电子设计与制造服务平台_专业PCB_PCBA_BOM_元器件_电子工程服务_高速PCB设计-造物云"
      }
    },
    {
      path: "/bomList",
      component: bomList,
      name: "bomList",
      mete: {
        requiresAuth: true,
        title:
          "造物云 | 电子设计与制造服务平台_专业PCB_PCBA_BOM_元器件_电子工程服务_高速PCB设计-造物云"
      }
    },
    {
      path: "/bomSubmit",
      component: bomSubmit,
      name: "bomSubmit",
      mete: {
        requiresAuth: true,
        title:
          "造物云 | 电子设计与制造服务平台_专业PCB_PCBA_BOM_元器件_电子工程服务_高速PCB设计-造物云"
      }
    },
    {
      path: "/testPage",
      component: testPage,
      name: "testPage",
      mete: {
        requiresAuth: true,
        title:
          "造物云 | 电子设计与制造服务平台_专业PCB_PCBA_BOM_元器件_电子工程服务_高速PCB设计-造物云"
      }
    },
    {
      path: "/compIndex",
      component: compIndex,
      name: "compIndex",
      mete: {
        requiresAuth: true,
        title:
          "造物云 | 电子设计与制造服务平台_专业PCB_PCBA_BOM_元器件_电子工程服务_高速PCB设计-造物云"
      }
    }
  ]
});

Router.beforeEach((to, form, next) => {
  console.log(to);
  if (to.params.type == "PCB" || to.params.type == "PCBA") {
    to.meta.title = "造物云_PCB询价_pcb在线计价_BOM询价_pcb加急打样";
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute(
        "content",
        "PCB计价,PCBA在线询价,BOM询价,IDM下单,pcb多层板,造物云"
      );
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        "造物云提供PCB,PCBA,BOM等产品一站式在线询价下单,覆盖产品研发全流程的服务平台.可自由选择产品参数,按要求进行定制化制造,一键价格评估,快速又便捷"
      );
  } else if (to.path == "/cad") {
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute(
        "content",
        "造物云高速PCB设计、SI设计、封装库、EMC设计与整改"
      );
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        "造物云致力于高速PCB设计，设计领域集中在通讯技术设施、工控主板。我们坚持以“客户为导向”，专注于为客户提供产品性能、成本和制造周期的合理解决"
      );
  } else {
    window.document.title =
      to.meta.title || "造物云_PCB询价_pcb在线计价_BOM询价_pcb加急打样";
  }
  // console.log(Router.app.$options.store.state.userGuid);
  //  console.log(to.matched);
  //  console.log(Router.app.$options.store.state);
  // let isLogin = Router.app.$options.store.state.authorToken;
  // if (to.matched.some((record) => record.meta.requireLogin)) {
  //   if (!isLogin) {
  //     common.toLogin();
  //     next(false);
  //   }
  // }

  next();
});

export default Router;




// WEBPACK FOOTER //
// ./src/router/index.js